import React, { useEffect, useState } from "react";
import { loadModelViewer, isModelViewerDefined } from "utils/loadModelViewer";
import ModelViewerInner from "./ModelViewer";

// Gate the 3D ModelViewer on the model-viewer web component being defined.
// ModelViewerInner drives the <model-viewer> element by ref (getCameraOrbit,
// .model, interactionPrompt, …), which only work once the custom element has
// upgraded. So we lazy-load public/model-viewer.js on mount and hold the inner
// component (and its ref calls) until it's defined. Turntable products render
// RenderTurntable instead and never reach here, so they never load the script.
const ModelViewer = (props) => {
  const [ready, setReady] = useState(isModelViewerDefined);
  useEffect(() => {
    if (ready) return undefined;
    let alive = true;
    loadModelViewer().then(() => {
      if (alive) setReady(true);
    });
    return () => {
      alive = false;
    };
  }, [ready]);
  // While the script loads, render nothing — the container shows its own scene
  // loader until ModelViewerInner mounts and calls setLoading(false).
  if (!ready) return null;
  return <ModelViewerInner {...props} />;
};

export default ModelViewer;
